import HttpClient from "../../../core/api/httpClient"

const baseUrl = '/api/reports'

export default class ReportApi {
    static async getQualityCheckReport(id: number): Promise<string|undefined> {
        const response = await HttpClient.get(`${baseUrl}/quality-check/${id}`)
        if (!response.ok) {
            return undefined
        }

        const blob = await response.blob()
        return URL.createObjectURL(blob)
    }
}
